import { useTranslation } from 'react-i18next'

export default function AvailabilityNotesCard({ availability }) {
	const { t } = useTranslation()
	const notes = availability?.notes?.trim()

	return (
		<section className="rounded-xl border border-gray-200 bg-white shadow-sm">
			<header className="border-b border-gray-200 p-6">
				<h2 className="text-lg font-semibold text-gray-900">
					{t('trainingAvailability.form.fields.notes')}
				</h2>
			</header>

			<div className="p-6">
				<p className="whitespace-pre-line text-sm text-gray-700">
					{notes || t('trainingAvailability.details.emptyNotes')}
				</p>
			</div>
		</section>
	)
}
